import { useQuery } from "react-query";
import { createApiWithPath } from "../../client";
import { queryKeys } from "../../query";
import { AllFieldTypesResponseData } from "../../types/field-type";

const fetchAllFieldTypes = async (
  search?: string,
): Promise<AllFieldTypesResponseData> => {
  const queryParams = new URLSearchParams();
  if (search && search.trim()) {
    queryParams.append("search", search.trim());
  }

  const queryString = queryParams.toString();
  const { data } = await createApiWithPath(
    "crm",
  ).get<AllFieldTypesResponseData>(
    `/field-types/all${queryString ? `?${queryString}` : ""}`,
  );

  return data;
};

interface UseFieldTypesFlatOptions {
  search?: string;
  enabled?: boolean;
}

export const useFieldTypesFlat = (options?: UseFieldTypesFlatOptions) => {
  const search = options?.search;
  const enabled = options?.enabled ?? true;

  return useQuery(
    queryKeys.fieldTypesFlat(search),
    () => fetchAllFieldTypes(search),
    { enabled },
  );
};
